import React from "react";

export default class KibanaFrame extends React.Component<any, any> {
    render() {
        return (
            <iframe title={"Kibana"} src={"https://dashboard.pengesoft.internal/kibana/app/discover"} style={{height: "100%", width: "100%"}} />
        )
    }
}
